export const LOADING_FORM_GIFT_CARD = 'LOADING_FORM_GIFT_CARD';
export const ERROR_FORM_GIFT_CARD = 'ERROR_FORM_GIFT_CARD';
export const RESET_FORM_GIFT_CARD = 'RESET_FORM_GIFT_CARD';
